import { Injectable } from '@angular/core';
import { ApiRequestService } from '@core/auth/api-request.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  _form = new BehaviorSubject<any>(null);

  constructor(private _ApiRequestService: ApiRequestService) { }

  getDynamicForm(formdata: any) {
    return this._ApiRequestService.postData(config.ticketing.raise.universal_form, formdata).pipe(switchMap((res: any) => {
      this._form.next(res)
      return of(res);
    }))
  }
}
